import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchProductCategories, fetchRawsList, importRaw } from '../../../../action/raw';
import { setUIvisible } from '../../../../action/UImobile';
import { setActiveModalAction } from '../../../../action';
import { CategoryListRaw } from '../../../../containers/rawmaterials/list/CategoryListRaw';
import HeadMobileActionMenu from '../../../../components/utils/HeadMobileActionMenu';
import { fromStore } from '../../../../selectors';
import { RawsList } from '../../../../containers';
import ErrorContainer from '../../../../components/utils/ErrorContainer';
import { utils, read, writeFileXLSX } from 'xlsx';
import swal from 'sweetalert';
import { isEmpty } from 'lodash';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { parseNumToFixed } from '../../../../utils/common';

export const measuresVariable = [
    { value: 'kg', variables: ['КГ', 'КГ.', 'КИЛОГРАММ', 'КИЛОГРАММЫ', 'КИЛОГРАММОВ'] },
    { value: 'liter', variables: ['Л', 'Л.', 'ЛИТР', 'ЛИТРЫ', 'ЛИТРОВ'] },
    { value: 'pc', variables: ['ШТ', 'ШТ.', 'ШТУК', 'ШТУКИ', 'ШТУКА'] }
]

function RawMaterialsList() {
    const dispatch = useDispatch();
    const activeCategory = useSelector(fromStore.activeCategoryRawSelector);
    const categories = useSelector(fromStore.categoriesRawByType('raw'));
    const raws = useSelector(fromStore.rawListSelector);
    const activeCategoryRaws = useSelector(fromStore.selectedCategoryRaws);
    const rawByType = useSelector(fromStore.selectedRawsByType('raw'))
    const refImport = useRef();

    const actionsMobile = [
        { name: 'Добавить сырье', icon: 'flaticon2-plus', action: () => onOpenModalGood() },
        { name: 'Добавить категорию', icon: 'flaticon2-plus', action: () => onOpenModalCategory() },
        { name: 'Редактировать категорию', icon: 'la la-edit', action: () => onOpenModalCategory(activeCategory) },
    ];

    const onRefresh = () => {
        dispatch(fetchRawsList());
        dispatch(fetchProductCategories('raw'));
    };

    useEffect(() => {
        if (isEmpty(categories)) dispatch(fetchProductCategories('raw'));
        dispatch(setUIvisible(false, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const onOpenModalCategory = (id) => {
        const categoryId = id || 'new';
        dispatch(setActiveModalAction({ field: 'categoryRaw', value: {id: categoryId, type: 'raw' } }));
    };

    const onOpenModalGood = (id) =>  {
        const goodId = id || 'new';
        dispatch(setActiveModalAction({ field: 'modalRaw', value: { id: goodId, type: 'raw' } }));
    }

    const onImport = async (e) => {
            if (!e.target.files[0]) {
                refImport.current.value = "";
                return swal({
                    title: "Ошибка импорта",
                    text: 'Файл не загружен',
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            }
    
            const file = e.target.files[0];
    
            if (!file.arrayBuffer) {
                refImport.current.value = "";
                return swal({
                    title: "Ошибка импорта",
                    text: 'Неверный формат данных',
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            }
    
            const data = await file.arrayBuffer();
    
            if (!data) {
                refImport.current.value = "";
                return swal({
                    title: "Ошибка импорта",
                    text: 'Данные не найдены',
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            }
    
            if(data) {
                const errors = [];

                const getMeasure = (text, name) => {
                    if (!text) {
                        errors.push(`Не указана ед. измерения для сырья ${name}`);
                        return null;
                    }
                    const result = measuresVariable.find((measure) => measure.variables.includes(text.toUpperCase()));
                    if (result && result.value) return result.value;
                    errors.push(`Ед. измерения ${text} не найдена`);
                }

                const getCategory = (text, name) => {
                    if (!text) {
                        errors.push(`Не указана категория для сырья ${name}. Сырье ${name} не было создано.`);
                        return null;
                    }
                    const result = categories.find((category) => String(category.title).toUpperCase() === String(text).toUpperCase());
                    if (result && result.id) return result.id;
                    errors.push(`Категория ${text} не найдена. Сырье ${name} не было создано.`);
                }

                const wb = read(data);
                const ws = wb.Sheets[wb.SheetNames[0]];
                const dataExcel = utils.sheet_to_json(ws);

                let rawmaterials = raws;
                if (isEmpty(rawmaterials)) rawmaterials = await dispatch(fetchRawsList(true, true));

                const importData = dataExcel.map((item) => {
                    const name = item['Название']
                    const rawData = rawmaterials.find((raw) => raw.name.toUpperCase() === String(name).toUpperCase());
                    const measure = getMeasure(item['Единица измерения'], name);
                    const productscategory = getCategory(item['Категория'], name);
                    if (!productscategory) return null;
                    const last_price = parseFloat(item['Цена']);
                    const minBalance = item['Минимальный остаток'];
                    const updated = (rawData && rawData.id) ? rawData.id : false;
                    return { name, measure, productscategory, last_price, minBalance, updated};
                }).filter((item) => item);

                if (importData && importData.length > 0) {
                    const result = await dispatch(importRaw(importData));
                    if (result && errors.length === 0) {
                        refImport.current.value = "";
                        return swal({
                            title: "Импорт выполнен",
                            icon: "success",
                            button: "Ок",
                        });
                    }

                    if (!result || result.length === 0) {
                        refImport.current.value = "";
                        return swal({
                            title: "Неизвестная ошибка импорта",
                            icon: "warning",
                            dangerMode: true,
                            button: "Ок",
                        }).then(() => onRefresh());
                    }

                    if (result && result.length > 0 && errors.length > 0) {
                        const errorText = errors.join(' | ');
                        refImport.current.value = "";
                        return swal({
                            title: "Импорт выполнен с ошибками",
                            text: errorText,
                            icon: "warning",
                            dangerMode: true,
                            button: "Ок",
                        });
                    }
                }

                const errorText = errors.join(' | ');
                return swal({
                    title: "Импорт не выполнен",
                    text: errorText,
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                });
            }
            refImport.current.value = "";
            
    }

    const onExport = (getAll) => {
        const arr = getAll ? rawByType : activeCategoryRaws;
        const exportData = arr.map((raw) => ({
            'id': raw.id,
            'Название': raw.name,
            'Цена': parseNumToFixed(raw.last_price) || 0,
            'Минимальный остаток': parseNumToFixed(raw.minBalance, 3),
            'Единица измерения': MEASURES_RAW[raw.measure],
            'Категория': raw.productscategory.title,
        }));
        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "История закупок");
        
        const category = !getAll ? categories.find((cat) => cat.id === activeCategory) : null;
        const categoryTitle = category && category.title ? category.title : null;
        writeFileXLSX(wb, `Сырье${(!getAll && categoryTitle) ? ` категория ${categoryTitle}` : ''}.xlsx`);
        }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Сырье</h3>
                </div>
                <div className="kt-subheader__toolbar">
                    <button className="btn btn-dark btn-icon-sm" onClick={() => onExport(false)}>
                        Экспорт категории
                    </button>
                    <button className="btn btn-dark btn-icon-sm" onClick={() => onExport(true)}>
                        Экспорт все
                    </button>
                    <label className="btn btn-dark btn-icon-sm" style={{ cursor: 'pointer' }}>
                        <input type="file" onChange={onImport} ref={refImport} hidden/>
                        Импорт
                    </label>
                    {window.innerWidth > 1024 && 
                        <button 
                        onClick={((e) => {
                            e.stopPropagation();
                            onOpenModalGood();
                        })}
                        className="btn btn-success btn-icon-sm"
                        >
                            Добавить сырье
                        </button>
                    }
                    <button onClick={onRefresh} className="btn btn-secondary btn-icon"><i className="la la-refresh"></i></button>
                </div>
            </div>
            </div>
        );
    };

    return (
        <div>
            <HeadMobileActionMenu actions={actionsMobile}/>
            { renderSubHeader() }
            <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <ErrorContainer field="raws" hasCloseButton={true}/>
                <ErrorContainer field="categoryRaws" hasCloseButton={true}/>
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo goods">
                    <div className='kt-grid__item kt-portlet kt-todo__aside goods'>
                       <CategoryListRaw/>
                    </div>
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <RawsList/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RawMaterialsList;